import React from 'react'
import { Button, Form, FormGroup } from 'reactstrap'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormFooter from '../../../common/forms/FormFooter'
import FormItem from '../../../common/forms/FormItem'
import Select from '../../../common/forms/select/Select'
import { DRIVER_STATUS_TYPE, MONTH_OPTIONS } from '../../../../config/constants'
import { exportFile } from '../../../../actions/traffic/DriverActivity'
import LocationSelect from '../../../common/forms/select/LocationSelect'
import DatePicker from '../../../common/forms/input/DatePicker'
import { isRequired, validateEndDate } from '../../../../utils/validators'
import { tzNormalizeDate } from '../../../../utils/date'
import { INT_DATE_FORMAT } from '../../../../config/locale'

const selector = formValueSelector('DriverActivitySearchForm')

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const DriverActivitySearchForm = ({
  handleSubmit,
  dispatchExportFile,
  driverStatusTypeValue,
  loading,
  homeBaseLocationValue,
  fromDateStringValue,
  toDateStringValue,
}) => {

  const handleExportToExcel = () => {
    const formValues = {
      fromDateString: tzNormalizeDate({ date: fromDateStringValue, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: toDateStringValue, format: INT_DATE_FORMAT }),
      driverStatusTypes: driverStatusTypeValue ? driverStatusTypeValue.map(status => status.value) : null,
      homeBaseLocationIds: homeBaseLocationValue && homeBaseLocationValue.length > 0
        ? homeBaseLocationValue.map(location => location.value)
        : null,
    }
    dispatchExportFile(formValues)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired, validateDate]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Base">
          <Field
            name="homeBaseLocation"
            component={LocationSelect}
            placeholder="Bases"
            forHomeBase
            isMulti
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Estado">
          <Field
            name="driverStatusType"
            component={Select}
            options={Object.values(DRIVER_STATUS_TYPE)}
            placeholder="Estado"
            isMulti
          />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonColor="primary"
        saveButtonText="Buscar"
        saveButtonIcon="fa fa-search"
        saveButtonDisabled={loading}
      >
        <Button type="button" color="secondary" onClick={handleExportToExcel}
          disabled={loading}
        >
          <i className="fa fa-file-excel-o mr-2" />
          Exportar a Excel
        </Button>
      </FormFooter>
    </Form>
  )
}

DriverActivitySearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatchExportFile: PropTypes.func.isRequired,
  driverStatusTypeValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  homeBaseLocationValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  loading: PropTypes.bool.isRequired,
  fromDateStringValue: PropTypes.string,
  toDateStringValue: PropTypes.string,
}

DriverActivitySearchForm.defaultProps = {
  driverStatusTypeValue: null,
  homeBaseLocationValue: null,
  fromDateStringValue: null,
  toDateStringValue: null,
}

const mapStateToProps = (state) => ({
  driverStatusTypeValue: selector(state, 'driverStatusType'),
  loading: state.TrafficUnit.DriverActivity.getIn(['all', 'loading']),
  homeBaseLocationValue: selector(state, 'homeBaseLocation'),
  fromDateStringValue: selector(state, 'fromDateString'),
  toDateStringValue: selector(state, 'toDateString'),
})

const mapDispatchToProps = {
  dispatchExportFile: exportFile
}


const form = reduxForm({
  form: 'DriverActivitySearchForm',
  initialValues: {
    month: {
      value: new Date().getMonth() + 1,
      label: MONTH_OPTIONS.find(
        (option) => option.value === new Date().getMonth() + 1,
      ).label,
    },
    year: new Date().getFullYear(),
  }
})(DriverActivitySearchForm)

export default connect(mapStateToProps, mapDispatchToProps)(form);